import React from 'react';

const Footer = ({params}) => (
<div className="footer">

  <p className="copyright f-level1">2018 Developed By Ibrahim Alkhudair :)</p>

  <div className="f-level2">
    <div className="info-right">
        <h3>Blogs مقالاتي</h3>
        <ul>
          <li><a href="/blogs/view/father" target="_blank">قصة والدي</a> <label style={{background: 'gray', padding: '5px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold', borderRadius: '10px'}}>Stories 📜</label></li>
          <li><a href="/blogs/view/قوة_الإرادة" target="_blank">قوة الإرادة</a> <label style={{background: 'gray', padding: '5px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold', borderRadius: '10px'}}>Emotional Intelligence 🧠</label></li>
          <li><a href="/blogs/view/password_attacks" target="_blank">Password Attacks</a> <label style={{background: 'gray', padding: '5px', textAlign: 'center', fontSize: '12px', fontWeight: 'bold', borderRadius: '10px'}}>Cybersecurity 🔒</label></li>
        </ul>
    </div>

    <div className="info-left">
        <h3>Projects اعمالي</h3>
        <ul>
          <li><a href="/works/view/Myksu" target="_blank">تطبيق تواصل اجتماعي</a></li>
          <li><a href="/works/view/Cashier_system" target="_blank">نظام كاشير محاسبي</a></li>
          <li><a href="/works/view/EmployPath" target="_blank">EmployPath</a></li>
        </ul>
    </div>
    <div className="info-center">
        <h3>Tutorial شروحاتي</h3>
        <ul>
          <li><a href="https://www.youtube.com/watch?v=SLyowqqblj4&t=3s" target="_blank">كورس أساسيات البرمجة بايثون</a></li>
          <li><a href="https://www.youtube.com/watch?v=GToeg2mkiIQ&list=PLRA10OrmscYlw-vncO737kx-tDhXhw3-x" target="_blank">كورس أساسيات الأمن السيبراني </a></li>
        </ul>
    </div>
    </div>

    <div className="f-level3">
      <div className="info-center">

        <address>
          Email contact <i className="far fa-envelope"></i> : <a href="mailto:x@ibrahim1.net">x@ibrahim1.net</a> <br/> 
          https://ibrahim1.net<br/>
          Riyadh, Saudi Arabia        
        </address>
      </div>
    </div>
</div>

);

export default Footer;
